const $ = jQuery.noConflict();

'use strict';
const counterNumber = {
	$domCounter: $('.js-counter-wrapper'),
	$domStampsTime: $('.js-count'),

	init: function() {
		this.conuterDecimal();
		$('.js-tabs').appendTo('.js-tab');
		$(function() {
			$('.js-count-single').each(function() {
				$(this).prop('Counter', 0).animate({
					Counter: $(this).text()
				}, {
					duration: 4000,
					easing: 'swing',
					step: function(now) {
						$(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
					}
				});
			});
		});
	},
	conuterDecimal: function() {
		if(counterNumber.$domCounter.length) {
			let seen = false;
			$(window).on('scroll', function() {
				if($(window).scrollTop() > counterNumber.$domCounter.offset().top - 800) {
					if(!seen) {
						$('.counter__number--hidden').fadeIn();
						counterNumber.$domStampsTime.each(function() {
							$(this).prop('Counter', 0).animate({
								Count: $(this).text()
							}, {
								duration: 3000,
								easing: 'linear',
								step: function(now) {
									$(this).text(Math.ceil(now).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'));
								},
							}
							);
						});
					}
					seen = true;
				}
			});
		}
	}
};
export default counterNumber;